import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 20v-11.5a4.5 4.5 0 1 0 -9 0v8.5","key":"svg-0"}],["path",{"d":"M11 14l-3 3l-3 -3","key":"svg-1"}]]

const IconUTurnLeft = createReactComponent('outline', 'u-turn-left', 'UTurnLeft', __iconNode);

export default IconUTurnLeft;